import { IssueTaskDoc } from '@gooduncles/gu-app-schema';
import { InputNumber, Select } from 'antd';
import { FC } from 'react';

import { formatNumber, parseKoreanCurrency } from 'src/utils/common';
import { updateIssueTask, updateIssueTaskNestedFields } from 'src/utils/firebase/firebase-short-cut';

import useDebouncedUpdate from 'src/hooks/useDebouncedUpdate';

import Description from 'src/atomic-components/atoms/Description';
import IssueCardSubTitle from 'src/atomic-components/atoms/IssueCardItem/IssueCardSubTitle';
import { IssueInfoItem } from 'src/atomic-components/atoms/IssueInfoItem/IssueInfoItem';

import styles from './IssueTaskCard.module.scss';

const TaskExternalServiceOptions = [
  {
    label: '디버',
    value: 'dver',
  },
  {
    label: '기타',
    value: 'etc',
  },
];

const TaskExternalServiceDescription = {
  dver: '* 디버(퀵서비스)를 이용합니다.',
  etc: '* 거래처에서 처리 또는 다른 방법으로 처리합니다.',
};

interface IssueTaskExternalServiceSectionProps {
  issueTaskDoc: IssueTaskDoc;
  editable: boolean;
}

const IssueTaskExternalServiceSection: FC<IssueTaskExternalServiceSectionProps> = ({ issueTaskDoc, editable }) => {
  const { externalService } = issueTaskDoc;

  const [cost, setCost] = useDebouncedUpdate(
    externalService?.cost ?? 0,
    async (value: number) => {
      try {
        await updateIssueTaskNestedFields(issueTaskDoc._id, {
          externalService: {
            cost: value,
          },
        });
      } catch (error) {
        console.error(error);
      }
    },
    1000
  );

  const onChangeExternalService = async (value: string) => {
    try {
      await updateIssueTask(issueTaskDoc._id, {
        externalService: {
          service: value as 'dver' | 'etc',
          requestId: null,
          cost: null,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  if (!externalService) return null;

  return (
    <div>
      <IssueCardSubTitle text='외부 서비스' />
      <div style={{ padding: '0px 8px 8px 8px' }}>
        <Select
          placeholder='이슈를 선택하세요'
          options={TaskExternalServiceOptions}
          value={issueTaskDoc.externalService?.service}
          styles={{
            root: {
              width: '100%',
            },
          }}
          onChange={onChangeExternalService}
          disabled={!editable}
        />
        <Description>{TaskExternalServiceDescription[externalService.service]}</Description>
      </div>
      <IssueInfoItem
        label='비용'
        value={
          <InputNumber
            step={100}
            value={cost}
            onChange={editable ? (value) => setCost(value ?? 0) : undefined}
            formatter={(value) => formatNumber(value ?? 0) + ' 원'}
            parser={parseKoreanCurrency}
            className={styles.inputNumberRight}
            disabled={!editable}
          />
        }
      />
    </div>
  );
};

export default IssueTaskExternalServiceSection;
